import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, withModifiers as _withModifiers, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "auth__left" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("h1", { class: "auth__title" }, "Regisztráció", -1)
const _hoisted_3 = /*#__PURE__*/_createElementVNode("p", { class: "auth__text" }, "Utolsó lépés! A felület személyre szabása", -1)
const _hoisted_4 = {
  key: 0,
  ref: "errorBlock",
  class: "form-errors"
}
const _hoisted_5 = { class: "form-errors__error" }
const _hoisted_6 = { class: "auth__row auth__form-group" }
const _hoisted_7 = { class: "auth__col" }
const _hoisted_8 = { class: "auth__col" }
const _hoisted_9 = { class: "auth__row auth__form-group" }
const _hoisted_10 = { class: "auth__col" }
const _hoisted_11 = { class: "auth__col" }
const _hoisted_12 = { class: "auth__form-group" }
const _hoisted_13 = { class: "auth__form-group" }
const _hoisted_14 = /*#__PURE__*/_createTextVNode(" Megismertem, és elfogadom az rtl.hu ")
const _hoisted_15 = /*#__PURE__*/_createElementVNode("a", {
  href: "https://rtl.hu/adatvedelmi-szabalyzat",
  target: "_blank"
}, "adatkezelési tájékoztatóját", -1)
const _hoisted_16 = /*#__PURE__*/_createTextVNode(" és az ")
const _hoisted_17 = /*#__PURE__*/_createElementVNode("a", {
  href: "https://rtl.hu/felhasznalasi-feltetelek",
  target: "_blank"
}, "általános szerződési feltételeit", -1)
const _hoisted_18 = /*#__PURE__*/_createTextVNode(". ")
const _hoisted_19 = /*#__PURE__*/_createElementVNode("button", {
  type: "submit",
  class: "auth__button auth__button--primary"
}, " Befejezés ", -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_text_input = _resolveComponent("text-input")!
  const _component_date_input = _resolveComponent("date-input")!
  const _component_Select = _resolveComponent("Select")!
  const _component_checkbox = _resolveComponent("checkbox")!
  const _component_modal = _resolveComponent("modal")!

  return (_ctx.modalIsOpen)
    ? (_openBlock(), _createBlock(_component_modal, {
        key: 0,
        onClose: _ctx.onModalClose
      }, {
        default: _withCtx(() => [
          _createElementVNode("div", _hoisted_1, [
            _hoisted_2,
            _hoisted_3,
            _createElementVNode("form", {
              class: "auth__form",
              onSubmit: _cache[6] || (_cache[6] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.register && _ctx.register(...args)), ["prevent"]))
            }, [
              (_ctx.hasFieldError('error'))
                ? (_openBlock(), _createElementBlock("ul", _hoisted_4, [
                    _createElementVNode("li", _hoisted_5, _toDisplayString(_ctx.getFieldErrorValue('error')), 1)
                  ], 512))
                : _createCommentVNode("", true),
              _createElementVNode("div", _hoisted_6, [
                _createElementVNode("div", _hoisted_7, [
                  _createVNode(_component_text_input, {
                    label: "Születési hely",
                    modelValue: _ctx.registerData.profile.hometown,
                    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.registerData.profile.hometown) = $event)),
                    "error-msg": _ctx.getFieldErrorValue('hometown')
                  }, null, 8, ["modelValue", "error-msg"])
                ]),
                _createElementVNode("div", _hoisted_8, [
                  _createVNode(_component_date_input, {
                    className: 'auth__form-control',
                    class: "account-form-control",
                    modelValue: _ctx.birthDate,
                    "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.birthDate) = $event)),
                    label: "Születési idő",
                    "error-msg": _ctx.getFieldErrorValue('birthDate')
                  }, null, 8, ["modelValue", "error-msg"])
                ])
              ]),
              _createElementVNode("div", _hoisted_9, [
                _createElementVNode("div", _hoisted_10, [
                  _createVNode(_component_Select, {
                    modelValue: _ctx.registerData.profile.gender,
                    "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.registerData.profile.gender) = $event)),
                    label: "Nem",
                    "error-msg": _ctx.getFieldErrorValue('gender'),
                    options: _ctx.genderOptions
                  }, null, 8, ["modelValue", "error-msg", "options"])
                ]),
                _createElementVNode("div", _hoisted_11, [
                  _createVNode(_component_text_input, {
                    label: "Irányítószám",
                    modelValue: _ctx.registerData.profile.zip,
                    "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.registerData.profile.zip) = $event)),
                    "error-msg": _ctx.getFieldErrorValue('zip')
                  }, null, 8, ["modelValue", "error-msg"])
                ])
              ]),
              _createElementVNode("div", _hoisted_12, [
                _createVNode(_component_checkbox, {
                  label: "Szeretnék hírlevelet kapni, hozzájárulok az rtl.hu ilyen irányú megkeresésének a fent megadott e-mail címen (Opcionális)",
                  modelValue: _ctx.registerData.data.RTLHU_Newsletter,
                  "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.registerData.data.RTLHU_Newsletter) = $event))
                }, null, 8, ["modelValue"])
              ]),
              _createElementVNode("div", _hoisted_13, [
                _createVNode(_component_checkbox, {
                  modelValue: _ctx.registerData.data.RTLHU_Consent,
                  "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.registerData.data.RTLHU_Consent) = $event)),
                  "error-msg": _ctx.getFieldErrorValue('RTLHU_Consent')
                }, {
                  default: _withCtx(() => [
                    _hoisted_14,
                    _hoisted_15,
                    _hoisted_16,
                    _hoisted_17,
                    _hoisted_18
                  ]),
                  _: 1
                }, 8, ["modelValue", "error-msg"])
              ]),
              _hoisted_19
            ], 32)
          ])
        ]),
        _: 1
      }, 8, ["onClose"]))
    : _createCommentVNode("", true)
}